/*=============================================
|                 IMPORTS                     |
=============================================*/
import axios from 'axios'
/*=============================================
|                CONSTANTES                   |
=============================================*/
const ENDPOINT_RASTREADOR = '/rastrear-pedido/'

const getMocked = ()  => {

  return [
    {
      "datos": {
        "id": 389,
        "n": "EM45428768",
        "f": 0,
        "tf": 1622181601,
        "tt": 1622267940,
        "trt": 3600,
        "uid": 40484361733255,
        "r": 500,
        "y": 25.7938499451,
        "x": -108.979919434,
        "u": 22884988,
        "s": 2,
        "sf": 512,
        "crt": 1622219577,
        "st": 1622219577,
        "cnm": 10289959.556,
        "if": 0,
        "nt": 0,
        "stt": 1622220087,
        "dtt": 1622220207,
        "eta": 0,
        "rd": 0,
        "ds": 0,
        "p": {
            "a": "Avenida Parque México, Fracc Los Mochis Centro, Ahome, Sinaloa 81200, Mexico",
            "aff": "",
            "c": "",
            "cid": "",
            "cm": "",
            "criterions": {
                "max_late": 0,
                "use_unloading_late": 1
            },
            "d": "",
            "e": "",
            "n": "EDIFICACION Y AGREGADOS LASO SOCIEDAD ANONIMA DE C",
            "ntf": 0,
            "p": "+6671030341",
            "p2": "",
            "r": {
                "i": 6,
                "id": 1622217986610,
                "m": 8364,
                "ndt": 1200,
                "t": 3295,
                "vt": 1622266068
            },
            "rep": true,
            "t": "",
            "uic": "",
            "ut": 2400,
            "v": 0,
            "w": 0,
            "z": ""
        },
        "ej": {
            "cm": "",
            "pos": {
                "lat": 25.7996565,
                "lon": -108.9661683
            },
            "tm": 1622219577
        },
        "dp": [
            103732050134145
        ],
        "tz": -100164208,
        "cf": {},
        "rp": "eqo|CvslxSuBdCsAxAkA|@??}C`B??}KvF??WL??RJ??TK??|EeC??nE{B??vCcB??|@s@~@cA??PQpBgC??LO??bB_CzIeL??`DeE??z@yA??tC{FvBoE??N[??tAuC??j@mA??F_@??R_@??LU??jAeC??zA_D??Vi@??tCaG??fBuD??d@eA??LUJU??bBqD??|CsG??tAcD??|@aB??fAn@??d@Z??p@`@??lBjA??|A~@??p@`@??f@Z??vA|@??vD|B??|CjB??xChB??pAx@??tA|@??~BvA??`CrA??NH??j@Z??JH??LW??P_@??JU??HS??|CsG??~CqG??tCiG??~@mB??pBiEr@sA??~@sB??JUXc@??HKv@w@??VWj@c@??J?XCP?L?T?T???TN??z@j@??d@Z??dDvBdEbC`DdB??~BnA??lAp@??zChB??dIzEjBl@??`@P??r@R??v@d@??fJlF??tEpC??dAp@??dIvE??PJ??JQ??FMTk@??LW??n@yA??p@wA??n@wA??l@qA??j@oA??f@eA??NY??j@uA??r@{A??p@uA??b@_A??l@oA??l@mA??l@mA??l@oA??p@sA??l@uA??l@oA??\\u@??N[??P_@HS??N[??p@yA??t@yA??p@wA??r@}A??hFbD??tD~B????",
        "images": [
          {
              "n": "mwl_om_image_1622215303.6607912889005936235.jpg",
              "s": 3846218,
              "ct": 1622219591,
              "mt": 1622219591
          },
          {
              "n": "mwl_om_image_1622215309.322108311032780437.jpg",
              "s": 3078841,
              "ct": 1622219601,
              "mt": 1622219601
          },
          {
              "n": "mwl_om_image_1622215320.2237381135285963013.jpg",
              "s": 3893724,
              "ct": 1622219614,
              "mt": 1622219614
          },
          {
              "n": "mwl_om_image_1622215993.7718025900386483834.jpg",
              "s": 5015850,
              "ct": 1622219632,
              "mt": 1622219632
          }
      ],
      "userId": 20073788
      },
      "code": 200,
      "success": true,
      "message": "¡El registro se encontró correctamente!"
    }
  ]

}

const getMocked2 = ()  => {

  return [
    {
      "datos": {
          "id": 346,
          "n": "EM45428768",
          "f": 32,
          "tf": 0,
          "tt": 86340,
          "trt": 3600,
          "uid": 146153442116702,
          "r": 500,
          "y": 25.7938499451,
          "x": -108.979919434,
          "u": 0,
          "s": 0,
          "sf": 0,
          "crt": 0,
          "st": 1622215803,
          "cnm": 0,
          "if": 0,
          "nt": 0,
          "stt": 0,
          "dtt": 0,
          "eta": 0,
          "rd": 0,
          "ds": 0,
          "p": {
              "a": "Avenida Parque México, Fracc Los Mochis Centro, Ahome, Sinaloa 81200, Mexico",
              "aff": "",
              "c": "",
              "cid": "",
              "cm": "",
              "criterions": {
                  "max_late": 0,
                  "use_unloading_late": 1
              },
              "d": "",
              "e": "",
              "n": "EDIFICACION Y AGREGADOS LASO SOCIEDAD ANONIMA DE C",
              "ntf": 0,
              "p": "+6671030341",
              "p2": "",
              "r": null,
              "t": "",
              "uic": "",
              "ut": 2400,
              "v": 0,
              "w": 0,
              "z": ""
          },
          "ej": {},
          "dp": null,
          "tz": -100164208,
          "cf": {},
          "rp": "",
          "images": {},
          "userId": 20073788
      },
      "code": 200,
      "success": true,
      "message": "¡El registro se encontró correctamente!"
    }
  ]

}

const getMocked3 = ()  => {

  return [
    {
      "datos": {
        "id": 447,
        "n": "MA10291119",
        "f": 0,
        "tf": 1623045601,
        "tt": 1623131940,
        "trt": 3600,
        "uid": 170750719821094,
        "r": 500,
        "y": 24.8376502991,
        "x": -107.362327576,
        "u": 22884982,
        "s": 2,
        "sf": 512,
        "crt": 1623088884,
        "st": 1623086173,
        "cnm": 97537355.3156,
        "if": 0,
        "nt": 1623081337,
        "stt": 1623086173,
        "dtt": 1623086371,
        "eta": 0,
        "rd": 0,
        "ds": 0,
        "p": {
            "a": "Carretera A Imala, Fracc Floresta, Culiacán, Sinaloa 80014, Mexico",
            "aff": "",
            "c": "",
            "cid": "",
            "cm": "",
            "criterions": {
                "max_late": 0,
                "use_unloading_late": 1
            },
            "d": "",
            "e": "",
            "n": "CONSTRUCTORA FINCASIN SA DE CV",
            "ntf": 0,
            "p": "+6442362136",
            "p2": "",
            "r": {
                "i": 1,
                "id": 1623080085740,
                "m": 0,
                "ndt": 1200,
                "t": 0,
                "vt": 1623082997
            },
            "rep": true,
            "t": "",
            "uic": "",
            "ut": 1800,
            "v": 0,
            "w": 0,
            "z": ""
        },
        "ej": {
            "cm": "se entrego material completo\n",
            "pos": {
                "lat": 24.8537246,
                "lon": -107.3518063
            },
            "tm": 1623088884
        },
        "dp": [
            178773718730021
        ],
        "tz": -100164208,
        "cf": {},
        "rp": "",
        "images": {},
      },
      "code": 200,
      "success": true,
      "message": "¡El registro se encontró correctamente!"
    }
  ]

}

const getMocked4 = ()  => {

  return [
    {
      "datos": {
        "id": 90,
        "n": "PA16348850",
        "f": 256,
        "tf": 1632463201,
        "tt": 1641020340,
        "trt": 2700,
        "uid": 29502130385845.0,
        "r": 500,
        "y": 24.7294006348,
        "x": -107.447669983,
        "u": 22884985,
        "s": 2,
        "sf": 512,
        "crt": 1632503699,
        "st": 1632503699,
        "cnm": 17920545.421,
        "if": 0,
        "nt": 0,
        "stt": 1632503837,
        "dtt": 1632504070,
        "eta": 0,
        "rd": 0,
        "ds": 0,
        "p": {
            "a": "5Ta Avenida, Rancho Campo Diez, Culiacán, Sinaloa 80396, Mexico",
            "aff": "",
            "c": "",
            "cid": "",
            "cm": "",
            "criterions": {
                "max_late": 0,
                "use_unloading_late": 1
            },
            "d": "Oswaldo Rodríguez",
            "e": "orodriguez@kuroda.com",
            "n": "JUAN JOSE MIRANDA",
            "ntf": 16,
            "p": "+6671513048",
            "p2": "",
            "r": {
                "i": 1,
                "id": 1632497324870,
                "m": 11292,
                "ndt": 1200,
                "t": 7987,
                "vt": 1632512922
            },
            "rep": true,
            "t": "",
            "uic": "",
            "ut": 7200,
            "v": 0,
            "w": 0,
            "z": ""
        },
        "ej": {
            "cm": "se entrego material completo\n",
            "pos": {
                "lat": 24.8537246,
                "lon": -107.3518063
            },
            "tm": 1632503699
        },
        "dp": null,
        "tz": -100164208,
        "cf": {},
        "rp": "",
        "images": {},
      },
      "code": 200,
      "success": true,
      "message": "¡El registro se encontró correctamente!"
    }
  ]

}

const callGetOrdes = (pedido)  => {

  let config = {
    auth: { username: "ubicApi", password:"Ap1$Ub1c$."}
  }


  return axios.get(
    ENDPOINT_RASTREADOR+pedido,
    config
  );
}



export default {
  getMocked,
  getMocked2,
  getMocked3,
  getMocked4,
  callGetOrdes,
}